import React, { Component } from 'react';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import moment from 'moment';
import queryString from 'query-string';
import { Button, Table, Image, Card, Icon, Label, Input } from 'semantic-ui-react';
import { CSVLink } from 'react-csv';
import numeral from 'numeral';

import {
  InstagramIcon,
} from 'dyzio-shared-components/lib/components/dyzio-icons';
import Error from '../../components/error';
import Loading from '../../components/loading';
import InstagramAccountType from '../../components/instagram-account-type';


import UserDetailsModal from '../../components/user-details-modal';

const _ = require('lodash');

const iconStyle = {
  height: '0.75em',
  margin: '0 5px',
};

const resetButtonStyles = {
  width: '150px',
  margin: '10px 0',
};

const PROFILE_KEY = 'DYZIO_PROFILE';
const roundImage = {
  borderRadius: '50%',
  margin: 'auto',
};

const cf = num => numeral(num).format('0,0');
const TabularShortlist = ({ influencers, organisation, handleSort }) => {
  const org = _.head(organisation);
  const getMediaLink = influencer => `${_.get(org, 'mediaKitUrl')}/media-kit/${influencer.id}`;

  const hasMediaKit = () => _.get(org, 'mediaKitUrl');

  console.log('TabularShortlist');
  return (
    <Table sortable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign="center">
          pic
          </Table.HeaderCell>
          <Table.HeaderCell
            onClick={() => handleSort('name')}
          >
          name
          </Table.HeaderCell>
          <Table.HeaderCell
            onClick={() => handleSort('instagram')}
          >
            <InstagramIcon size="small" style={iconStyle} />instagram
          </Table.HeaderCell>
          <Table.HeaderCell
            onClick={() => handleSort('instagramCount')}
            textAlign="center"
          >
            <InstagramIcon size="small" style={iconStyle} />followers
          </Table.HeaderCell>
          <Table.HeaderCell
            onClick={() => handleSort('instagramEngagementRate')}
            textAlign="center"
          >
            <InstagramIcon size="small" style={iconStyle} />E.R.
          </Table.HeaderCell>
          <Table.HeaderCell
            onClick={() => handleSort('tiktok')}
          >
            <img style={iconStyle} src={'/icons/tiktok.svg'} alt="Tiktok" />tiktok
          </Table.HeaderCell>
          <Table.HeaderCell
            onClick={() => handleSort('tiktokCount')}
            textAlign="center"
          >
            <img style={iconStyle} src={'/icons/tiktok.svg'} alt="Tiktok" />followers
          </Table.HeaderCell>
          <Table.HeaderCell
            onClick={() => handleSort('tiktokProfileData.engagementData.engagementRate')}
            textAlign="center"
          >
            <img style={iconStyle} src={'/icons/tiktok.svg'} alt="Tiktok" />E.R.
          </Table.HeaderCell>
          { hasMediaKit() &&
          <Table.HeaderCell>
            Media Link
          </Table.HeaderCell>}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {
          _.map(influencers, influencer => {
            const { name, instagram, instagramCount, instagramEngagementRate,
              instagramProfessionalAccount, instagramBusinessAccount, instagramRestrictedProfile,
              instagramRestrictedProfileText, instagramPrivate, tiktok, tiktokCount } = influencer;
            return (
              <Table.Row>
                <Table.Cell>
                  <a href={`https://www.instagram.com/${instagram}`} target="_blank" rel="noopener noreferrer">
                    <Image size="mini" src={influencer.thumbnail} circular style={roundImage} />
                  </a>
                </Table.Cell>
                <Table.Cell>
                  {name}
                </Table.Cell>
                <Table.Cell negative>
                  <InstagramAccountType
                    instagram={instagram}
                    isProfessional={instagramProfessionalAccount}
                    isBusiness={instagramBusinessAccount}
                    isRestricted={instagramRestrictedProfile}
                    restrictedText={instagramRestrictedProfileText}
                    isPrivate={instagramPrivate}
                  />
                  <a href={`https://www.instagram.com/${instagram}`} target="_blank" rel="noopener noreferrer">{instagram || '-'}</a>
                </Table.Cell>
                <Table.Cell negative textAlign="center">
                  {cf(instagramCount)}
                </Table.Cell>
                <Table.Cell negative textAlign="center">
                  {instagramEngagementRate}%
                </Table.Cell>
                <Table.Cell>
                  { tiktok && <a href={`https://www.tiktok.com/@${tiktok}`} target="_blank" rel="noopener noreferrer">{tiktok}</a>}
                  { !tiktok && '-'}
                </Table.Cell>
                <Table.Cell textAlign="center">
                  {tiktokCount ? cf(tiktokCount) : '-'}
                </Table.Cell>
                <Table.Cell textAlign="center">
                  {_.get(influencer, 'tiktokProfileData.engagementData.engagementRate', '-')}%
                </Table.Cell>
                { hasMediaKit() &&
                <Table.Cell>
                  <a href={getMediaLink(influencer)} target="_blank" rel="noopener noreferrer"><Button>OPEN</Button></a>
                </Table.Cell>}
              </Table.Row>
            );
          },
          )
        }
      </Table.Body>
    </Table>
  );
};

class ShortlistContainer extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      shortlist: null,
      error: null,
      shortlistId: null,
      allInfluencers: [],
      influencers: [],
      sort: null,
      sortDesc: false,
    };

    this.client = axios.create({
      // baseURL: process.env.REACT_APP_API_URL,
      baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/shortlists',
      timeout: 30000,
    });

    axiosRetry(this.client, {
      retries: 3,
      delay: 100,
      retryCondition: error => !error.response || (error.response.status >= 500 && error.response.status <= 599),
    });
  }

  componentDidMount = () => {
    const { shortlistId } = this.props.match.params;

    const qs = this.props.location.search;

    const parsed = queryString.parse(qs);
    console.log(parsed);
    let email = parsed.email || null;
    let isProfileSet = false;

    if (!email) {
      const profile = this.getProfile();
      console.log(profile);
      email = profile && profile.email;
      isProfileSet = _.has(profile, 'email');
    }

    console.log(email);
    // put the email into local storage
    // https://www.npmjs.com/package/localStorage
    // https://www.npmjs.com/package/local-storage

    // create a form with name and email
    this.setState({
      shortlistId,
      email,
      isProfileSet,
    });

    this.client.get(`/v2/${shortlistId}`)
      .then(r => {
        const { shortlist } = r.data.data;
        console.log(shortlist);
        const { linksMap, links } = r.data;
        if (shortlist.status !== 'COMPLETED') {
          this.handleViewed();
        }
        this.setState({
          loading: false,
          shortlist,
          linksMap,
          links,
          influencers: shortlist.influencers,
          allInfluencers: shortlist.influencers,
        });
      })
      .catch(error => {
        window.onerror(error);
        this.setState({
          error,
        });
      });
  }

  resetProfile = () => {
    localStorage.setItem(PROFILE_KEY, null);
    this.setState({
      profile: null,
      email: null,
      isProfileSet: false,
    });
  }

  getProfile = () => {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem(PROFILE_KEY);
    return profile ? JSON.parse(profile) : null;
  }

  setProfile = profile => {
    console.log(profile);
    localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
    this.setState({
      profile,
      email: profile.email,
      isProfileSet: true,
    });
  }

  handleApprove = (user, influencerId) => {
    const { email } = this.state;
    const approval = { influencerId,
      type: 'APPROVE',
      message: `${email} approved on ${moment(new Date()).format('DD MMM YYYY')}`,
    };

    this.postApproval(approval);
  }

  handleReject = (user, influencerId) => {
    const { email } = this.state;
    const approval = { influencerId,
      type: 'REJECT',
      message: `${email} rejected on ${moment(new Date()).format('DD MMM YYYY')}`,
    };

    this.postApproval(approval);
  }

  handleSubmit = () => {
    const { shortlistId } = this.state;
    this.client.patch(`/${shortlistId}`, {
      data: {
        status: 'COMPLETED',
      },
    }).then(r => {
      const newShortlist = r.data.data;
      const { shortlist } = this.state;
      shortlist.status = newShortlist.status;
      this.setState({
        shortlist,
      });
    })
      .catch(error => {
        this.setState({
          error,
        });
      });
  }

  handleViewed = () => {
    const { shortlistId } = this.state;
    this.client.patch(`/${shortlistId}`, {
      data: {
        status: 'VIEWED',
      },
    }).then(r => {
      console.log('status set to VIEWED');
    });
  }

  postApproval = approval => {
    const { shortlistId } = this.state;
    this.client.post(`/${shortlistId}`, {
      data: {
        approval,
      },
    }).then(r => {
      const newShortlist = r.data.data;
      const { shortlist } = this.state;
      shortlist.dataMap = newShortlist.dataMap;
      this.setState({
        shortlist,
      });
    })
      .catch(error => {
        this.setState({
          error,
        });
      });
  }

  orderByWithNullsAtEnd = (pArray: any[], pAttr: string, pReverse: boolean) => {
    const partition = _.partition(pArray, x => !!_.get(x, pAttr, null));
    return _.concat(_.orderBy(partition[0], pAttr, (pReverse ? 'desc' : 'asc')), partition[1]);
  }

  handleSearchChange = (e, { value }) => {
    const { shortlist, allInfluencers } = this.state;
    shortlist.influencers = _.filter(allInfluencers,
      inf => _.includes(inf.name, value) || _.includes(inf.instagram, value));
    this.setState({
      shortlist,
    });
  };

  handleSort = newSort => {
    const { shortlist, sort, sortDesc } = this.state;

    let newSortDesc = false;

    if (sort === newSort) {
      newSortDesc = !sortDesc;
    }

    if (newSort === 'instagramEngagedFollowers') {
      _.forEach(shortlist.influencers, inf => {
        _.assignIn(inf,
          { instagramEngagedFollowers: Math.round((inf.instagramCount * inf.instagramEngagementRate) / 100) },
        );
      });
    }

    shortlist.influencers = this.orderByWithNullsAtEnd(shortlist.influencers, newSort, newSortDesc);

    console.log(sort);
    this.setState({
      sort: newSort,
      shortlist,
      sortDesc: newSortDesc,
    });
  }


  render = () => {
    const { shortlist, error, isProfileSet, email } = this.state;
    const { isShortlistApprovalDisabled } = shortlist || {};

    let basicData = null;
    let filename;
    const timestamp = moment().format('YYYY-MM-DD');

    if (shortlist) {
      const influencers = _.map(shortlist.influencers, inf => {
        const flattenInf = inf;
        flattenInf.tiktokEngagementRate = _.get(inf, 'tiktokProfileData.engagementData.engagementRate');
        return flattenInf;
      });
      console.log('influencers', influencers);

      filename = `${_.kebabCase(shortlist.name)}-${timestamp}.csv`;
      const fields = [
        'thumbnail',
        'name',
        'instagram',
        'email',
        'instagramCount',
        'instagramEngagementRate',
        'tiktok',
        'tiktokCount',
        'instagramId',
        'tiktokId'
      ];
      basicData = _.map(influencers, i => _.pick(i, fields));
    }

    if (shortlist) {
      return (
        <div>

          <Card fluid>
            <Card.Content header={_.toUpper(shortlist.name)} />
            <Card.Content description="Shortlist notes" />
            <Card.Content>
              <div dangerouslySetInnerHTML={{ __html: shortlist.notes }} />
            </Card.Content>

            <Card.Content style={{ textAlign: 'right' }}>
              <Label basic size="large" color="pink">
                <Icon name="file excel outline" />
                <CSVLink data={basicData} filename={filename}>EXPORT LIST</CSVLink>
              </Label>

            </Card.Content>
          </Card>

          <Input
            fluid
            icon="filter"
            placeholder="Filter My Influencers"
            iconPosition="left"
            onChange={this.handleSearchChange}
          />

          <TabularShortlist
            influencers={shortlist.influencers} organisation={shortlist.organisation}
            handleSort={this.handleSort}
          />
          {
            !email && !isShortlistApprovalDisabled &&
            <div>
              <UserDetailsModal
                open={!isProfileSet}
                resourceType="shortlist"
                successHandler={this.setProfile}
              />
            </div>
          }
          {
            isProfileSet && !isShortlistApprovalDisabled &&
            <div>
              <Button
                basic
                negative
                style={resetButtonStyles}
                onClick={this.resetProfile}
                content="reset profile"
              />
            </div>
          }
        </div>
      );
    }

    if (error) {
      return (
        <Error error={error} />
      );
    }

    return (
      <Loading resource="shortlist" />
    );
  }
}

export default ShortlistContainer;



// WEBPACK FOOTER //
// ./src/containers/shortlist-v3/index.js